export default "__VITE_ASSET__LGstEheh__"